import { render, staticRenderFns } from "./footer-policy.vue?vue&type=template&id=7fd3a85c&scoped=true&"
import script from "./footer-policy.vue?vue&type=script&lang=js&"
export * from "./footer-policy.vue?vue&type=script&lang=js&"
import style0 from "./footer-policy.vue?vue&type=style&index=0&id=7fd3a85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd3a85c",
  null
  
)

export default component.exports